import { render } from "./EditarVagaVie.vue?vue&type=template&id=1d765a5d"
import script from "./EditarVagaVie.vue?vue&type=script&lang=js"
export * from "./EditarVagaVie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__